import { InstagramLogo, TiktokLogo } from "phosphor-react";
import TwitterXLogo from "../../public/icons/TwitterXLogo";
import CustomDiscordLogo from "../../public/icons/custom-discord-logo";
import {
  BrandImageType,
  CampaignsSortBy,
  EngagementType,
  ExclusiveContentFilterBy,
  FilterBy,
  ProofSubType,
  Providers,
  QuestCategory,
  QuestFilterBy,
  QuestGameSlug,
  QuestLear2EarnSlug,
  QuestMenuActions,
  QuestPollSlug,
  QuestProofSlug,
  QuestQuizSlug,
  QuestSurveysSlug,
  QuizQuestCategory,
  SortBy,
  TransactionCategory,
  TransactionStatus,
  TransactionType,
  UserQuestStatus,
} from "../utils/enums";

export const brandBackgroundColor = [
  { name: "Black", code: "#000000" },
  { name: "White", code: "#FFFFFF" },
];

export enum ToastContainerIds {
  APP_INSTALL_PROMPT_TOAST = "app_install_prompt_toast",
  PUSH_NOTIFICATIONS_PROMPT_TOAST = "push_notifications_prompt_toast",
}

export const brandUpdateFields = [
  {
    name: "title",
    label: "Company Name",
    placeholder: "Name",
  },
  {
    name: "website_url",
    label: "Company Website",
    placeholder: "Add Url",
  },
  {
    name: "currency",
    label: "Currency",
    placeholder: "Add Currency",
  },
  {
    name: "privacy_policy_url",
    label: "Privacy Policy",
    placeholder: "Add Link",
  },
  {
    name: "terms_and_condition_url",
    label: "Terms and conditions",
    placeholder: "Add Link",
  },
  {
    name: "discord_url",
    label: "Discord",
    placeholder: "Add Url",
  },
  {
    name: "instagram_url",
    label: "Instagram",
    placeholder: "Add Url",
  },
  {
    name: "tiktok_url",
    label: "Tik Tok",
    placeholder: "Add Url",
  },
  {
    name: "youtube_url",
    label: "Youtube",
    placeholder: "Add Url",
  },
  // {
  //     name: 'twitter_url',
  //     label: 'Twitter',
  //     placeholder: 'Add Url'
  // },
];

export const adminFilters = [
  {
    text: "Live",
    filterBy: FilterBy.live,
  },
  {
    text: "Archived",
    filterBy: FilterBy.archived,
  },
  {
    text: "Draft",
    filterBy: FilterBy.DRAFT,
  },
  {
    text: "Sold Out",
    filterBy: FilterBy.sold_out,
  },
  {
    text: "Coming Soon",
    filterBy: FilterBy.coming_soon,
  },
];

export const showClaimsQuestFilters = [
  {
    text: "Claimed",
    filterBy: UserQuestStatus.CLAIMED,
  },
  {
    text: "Pending",
    filterBy: UserQuestStatus.PENDING,
  },
  {
    text: "Rejected",
    filterBy: UserQuestStatus.REJECTED,
  },
];

export const questFilters = [
  {
    text: "Live",
    filterBy: QuestFilterBy.live,
  },
  {
    text: "Archived",
    filterBy: QuestFilterBy.archived,
  },
  {
    text: "Draft",
    filterBy: QuestFilterBy.draft,
  },
  {
    text: "exhausted",
    filterBy: QuestFilterBy.exhausted,
  },
  {
    text: "Coming Soon",
    filterBy: QuestFilterBy.coming_soon,
  },
  {
    text: "Ended",
    filterBy: QuestFilterBy.past,
  },
];

export const userQuestFilters = [
  {
    text: "Live",
    filterBy: QuestFilterBy.live,
  },

  {
    text: "exhausted",
    filterBy: QuestFilterBy.exhausted,
  },
];

export const myItemsFilters = [
  {
    text: "Discount",
    filterBy: "Discount",
  },
  {
    text: "Allowlist",
    filterBy: "Allowlist",
  },
  {
    text: "Art",
    filterBy: "Art",
  },
  {
    text: "Merchandise",
    filterBy: "Merchandise",
  },
  {
    text: "NFT",
    filterBy: "NFT",
  },
  // {
  //   text: "Comics",
  //   filterBy: "Comics",
  // },
  {
    text: "Experience",
    filterBy: "Experience",
  },
  // {
  //   text: "NFH IQ",
  //   filterBy: "NFH IQ",
  // },
  {
    text: "POAP",
    filterBy: "POAP",
  },
  {
    text: "Raffle",
    filterBy: "Raffle",
  },
  // {
  //   text: "The Frontier",
  //   filterBy: "The Frontier",
  // },
  {
    text: "Service",
    filterBy: "Service",
  },
];

export const allFonts = [
  {
    label: "Humana Light",
    value: "Humana Light",
    styles: {
      fontFamily: "Humana Light",
    },
  },
  {
    label: "Humana Bold",
    value: "Humana Bold",
    styles: {
      fontFamily: "Humana Bold",
    },
  },
  {
    label: "Humana Regular",
    value: "Humana Regular",
    styles: {
      fontFamily: "Humana Regular",
    },
  },
  {
    label: "Abril Fatface",
    value: "Abril Fatface",
    styles: {
      fontFamily: "Abril Fatface",
    },
  },
  {
    label: "Bebas Neue",
    value: "Bebas Neue",
    styles: {
      fontFamily: "Bebas Neue",
    },
  },
  {
    label: "Biennale",
    value: "Biennale",
    styles: {
      fontFamily: "Biennale",
    },
  },
  {
    label: "Blaster",
    value: "Blaster",
    styles: {
      fontFamily: "Blaster",
    },
  },
  {
    label: "Changa One",
    value: "Changa One",
    styles: {
      fontFamily: "Changa One",
    },
  },
  {
    label: "Droid Sans",
    value: "Droid Sans",
    styles: {
      fontFamily: "Droid Sans",
    },
  },
  {
    label: "Exo",
    value: "Exo",
    styles: {
      fontFamily: "Exo",
    },
  },
  {
    label: "Great Vibes",
    value: "Great Vibes",
    styles: {
      fontFamily: "Great Vibes",
    },
  },
  {
    label: "Helvetica",
    value: "Helvetica",
    styles: {
      fontFamily: "Helvetica",
    },
  },
  {
    label: "Inconsolata",
    value: "Inconsolata",
    styles: {
      fontFamily: "Inconsolata",
    },
  },
  {
    label: "Inter",
    value: "Inter",
    styles: {
      fontFamily: "Inter",
    },
  },
  {
    label: "Josefin Sans",
    value: "Josefin Sans",
    styles: {
      fontFamily: "Josefin Sans",
    },
  },
  {
    label: "Lato",
    value: "Lato",
    styles: {
      fontFamily: "Lato",
    },
  },
  {
    label: "League Spartan",
    value: "League Spartan",
    styles: {
      fontFamily: "League Spartan",
    },
  },
  {
    label: "Libre Baskerville",
    value: "Libre Baskerville",
    styles: {
      fontFamily: "Libre Baskerville",
    },
  },
  {
    label: "Merriweather",
    value: "Merriweather",
    styles: {
      fontFamily: "Merriweather",
    },
  },
  {
    label: "Montserrat",
    value: "Montserrat",
    styles: {
      fontFamily: "Montserrat",
    },
  },
  {
    label: "Nunito",
    value: "Nunito",
    styles: {
      fontFamily: "Nunito",
    },
  },
  {
    label: "Oswald",
    value: "Oswald",
    styles: {
      fontFamily: "Oswald",
    },
  },
  {
    label: "Pacifico",
    value: "Pacifico",
    styles: {
      fontFamily: "Pacifico",
    },
  },
  {
    label: "Poppins",
    value: "Poppins",
    styles: {
      fontFamily: "Poppins",
    },
  },
  {
    label: "PT Sans",
    value: "PT Sans",
    styles: {
      fontFamily: "PT Sans",
    },
  },
  {
    label: "PT Serif",
    value: "PT Serif",
    styles: {
      fontFamily: "PT Serif",
    },
  },
  {
    label: "Raleway",
    value: "Raleway",
    styles: {
      fontFamily: "Raleway",
    },
  },
  {
    label: "Rethink Sans",
    value: "Rethink Sans",
    styles: {
      fontFamily: "Rethink Sans",
    },
  },
  {
    label: "Roboto",
    value: "Roboto",
    styles: {
      fontFamily: "Roboto",
    },
  },
  {
    label: "Sacramento",
    value: "Sacramento",
    styles: {
      fontFamily: "Sacramento",
    },
  },
  {
    label: "Saira",
    value: "Saira",
    styles: {
      fontFamily: "Saira",
    },
  },
  // {
  //   label: "Slabo",
  //   value: "Slabo 13px",
  // },
  {
    label: "Source Sans Pro",
    value: "Source Sans Pro",
    styles: {
      fontFamily: "Source Sans Pro",
    },
  },
  {
    label: "Thyga",
    value: "Thyga",
    styles: {
      fontFamily: "Thyga",
    },
  },
  {
    label: "Thyga Italisised",
    value: "Thyga_Italic",
    styles: {
      fontFamily: "Thyga_Italic",
    },
  },
  {
    label: "Ubuntu",
    value: "Ubuntu",
    styles: {
      fontFamily: "Ubuntu",
    },
  },
  {
    label: "Varela",
    value: "Varela",
    styles: {
      fontFamily: "Varela",
    },
  },
  {
    label: "Varela Round",
    value: "Varela Round",
    styles: {
      fontFamily: "Varela Round",
    },
  },
  {
    label: "Vollkorn",
    value: "Vollkorn",
    styles: {
      fontFamily: "Vollkorn",
    },
  },
  {
    label: "KumbhSans",
    value: "KumbhSans",
    styles: {
      fontFamily: "KumbhSans",
    },
  },
  {
    label: "Fredoka",
    value: "Fredoka",
    styles: {
      fontFamily: "Fredoka",
    },
  },
  {
    label: "Poppins Bold",
    value: "Poppins Bold",
    styles: {
      fontFamily: "Poppins Bold",
    },
  },
  {
    label: "Poppins SemiBold",
    value: "Poppins SemiBold",
    styles: {
      fontFamily: "Poppins SemiBold",
    },
  },
];

export const primaryFonts = allFonts.filter(
  (font) =>
    font.value !== "Humana Regular"
);

export const secondaryFonts = allFonts;

export const activities = [
  {
    title: "Challenges",
    icon: (className?: string) => <TwitterXLogo className={className} />,
    provider: Providers.QUEST,
  },
  {
    title: `X (Twitter)`,
    icon: (className?: string) => <TwitterXLogo className={className} />,
    provider: Providers.TWITTER,
  },
  {
    title: `Discord`,
    icon: (className?: string) => <CustomDiscordLogo className={className} />,
    provider: Providers.DISCORD,
  },
  // {
  //   title: `Youtube`,
  //   icon: (className?: string) => <YoutubeLogo className={className} />,
  //   provider: Providers.YOUTUBE,
  // },
  // {
  //   title: `Spotify`,
  //   icon: (className?: string) => <SpotifyLogo className={className} />,
  //   provider: Providers.SPOTIFY,
  // },
  // {
  //   title: `LinkedIn`,
  //   icon: (className?: string) => <LinkedinLogo className={className} />,
  //   provider: Providers.LINKEDIN,
  // },
  {
    title: `Instagram`,
    icon: (className?: string) => <InstagramLogo className={className} />,
    provider: Providers.INSTAGRAM,
  },
  {
    title: `TikTok`,
    icon: (className?: string) => <TiktokLogo className={className} />,
    provider: Providers.TIKTOK,
  },
  // {
  //     title: `Gmail Activities`,
  //     provider: Providers.GMAIL
  // },
  // {
  // 	title: `More Activities`,
  // 	provider: `other`,
  // },
];

export const sortMenu = [
  { text: "Recently Updated", sortBy: SortBy.updated_at },
  { text: "Price - Low to High", sortBy: SortBy.value_asc },
  { text: "Price - High to Low", sortBy: SortBy.value_desc },
];

export const ExclusiveShortMenu = [
  { text: "Recently Updated", sortBy: SortBy.updated_at },
  { text: "A - Z", sortBy: SortBy.title_asc },
  { text: "Z - A", sortBy: SortBy.title_desc },
  { text: "Oldest Updated", sortBy: SortBy.oldest_updated },
];

export const campaignsSortMenu = [
  { text: "Recently Updated", sortBy: CampaignsSortBy.updated_at },
  { text: "Claimed - Low to High", sortBy: CampaignsSortBy.value_asc },
  { text: "Claimed - High to Low", sortBy: CampaignsSortBy.value_desc },
];

export const userFilters = [
  {
    text: "Live",
    filterBy: FilterBy.live,
  },
  {
    text: "Sold Out",
    filterBy: FilterBy.sold_out,
  },
];

export const engagementTableHeadings = [
  "",
  "Engagement",
  "Account/Provider ID",
  "Date",
  "Link",
  "Amt",
  <span key={"max_allowed"}>
    Max Allowed<sup>#</sup>
  </span>,
  <span key={"claimed"}>
    Claimed<sup>#</sup>
  </span>,
  "Interaction",
  "Status",
  "Actions",
];
export const itemStatsMetaTableHeadings = [
  "",
  "Tx ID",
  "Quantity",
  "Amount",
  "Email/Discord",
  "Purchase Time",
];
export const itemStatsTableHeadings = [
  "",
  "User",
  "Total Quantity",
  "Last Purchase Time",
  "Action",
];

export const brandImageSetting = [
  {
    label: "Your Logo*",
    meta: {
      dimension: "500 x 500",
    },
    placeholderImage: "",
    type: BrandImageType.LOGO,
    accept: ".png, .jpeg, .jpg",
  },
  {
    label: "Banner Image*",
    meta: {
      dimension: "1200 x 100",
      text: "Click to upload",
    },
    placeholderImage: "",
    type: BrandImageType.BANNER,
    accept: ".png, .jpeg, .jpg",
  },
  {
    label: "Share Image",
    meta: {
      dimension: "1600 x 900",
    },
    placeholderImage: "",
    type: BrandImageType.SHARE_IMAGE,
    accept: ".png, .jpeg, .jpg",
  },
  {
    label: "Favicon",
    meta: {
      dimension: "48 x 48",
    },
    placeholderImage: "",
    type: BrandImageType.FAVICON,
    accept: ".ico",
  },
];

export const engagementActions = ["edit", "duplicate", "pause"];

export const ExclusiveContentActionsMap = [
  "edit",
  "duplicate",
  "Remove",
  "Archived",
  "Published",
  "Draft",
];
export const socialLoginTimeOut = 300000; //in ms
export const questCategory = [
  {
    label: "Game",
    shortLabel: "Game",
    category: QuestCategory.GAME,
  },
  {
    label: "Learn2Earn",
    shortLabel: "L2E",
    category: QuestCategory.LEARN_2_EARN,
  },
  {
    label: "Quiz",
    shortLabel: "Quiz",
    category: QuestCategory.QUIZ,
  },
  {
    label: "Poll",
    shortLabel: "Poll",
    category: QuestCategory.POLL,
  },
  {
    label: "Survey",
    shortLabel: "Survey",
    category: QuestCategory.SURVEY,
  },
  {
    label: "Refer A Friend",
    shortLabel: "Refer",
    category: QuestCategory.REFER_2_EARN,
  },
  {
    label: "Proof Needed",
    shortLabel: "Proof",
    category: QuestCategory.PROOF,
  },
  // {
  //   label: "Suggestion Box",
  //   shortLabel: "Suggest"
  //   category: QuestCategory.SUGGESTION_BOX,
  // },
  // {
  //   label: "Create Your Own",
  //   category: QuestCategory.CUSTOM,
  // },
];

export const questCategorySlugs = {
  [QuestCategory.LEARN_2_EARN]: [QuestLear2EarnSlug.VIDEO_URL],
  [QuestCategory.QUIZ]: [QuestQuizSlug.QUESTIONS],
  [QuestCategory.POLL]: [QuestPollSlug.POLL_QUESTIONS],
  [QuestCategory.SURVEY]: [QuestSurveysSlug.QUESTIONS],
  [QuestCategory.PROOF]: [QuestProofSlug.PROOF],
  [QuestCategory.GAME]: [QuestGameSlug.GAME_URL],
};

export const quizQuestCategory = [
  {
    label: "Multiple choice",
    category: QuizQuestCategory.MULTIPLE_CHOICE,
  },
  {
    label: "Single choice",
    category: QuizQuestCategory.SINGLE_CHOICE,
  },
];

export const proofQuestTypes = [
  { value: ProofSubType.MEDIA, label: "Upload Image or Video" },
  { value: ProofSubType.TEXT, label: "Input Text" },
];

export const questMenuActions = [
  {
    label: "Start Challenge",
    value: QuestMenuActions.START,
  },
  // {
  //   label: "More Info",
  //   value: QuestMenuActions.INFO,
  // },
  // {
  //   label: "Hide",
  //   value: QuestMenuActions.HIDE,
  // },
  // {
  //   label: "Skip",
  //   value: QuestMenuActions.SKIP,
  // },
];

export const AdminExclusiveContentFilters = [
  {
    text: "Live",
    filterBy: ExclusiveContentFilterBy.LIVE,
  },
  {
    text: "Archived",
    filterBy: ExclusiveContentFilterBy.ARCHIVED,
  },
  {
    text: "Draft",
    filterBy: ExclusiveContentFilterBy.DRAFT,
  },
  {
    text: "Coming Soon",
    filterBy: ExclusiveContentFilterBy.COMING_SOON,
  },
  {
    text: "Past",
    filterBy: ExclusiveContentFilterBy.PAST,
  },
];

export const popoverCartElement = [
  EngagementType.JOIN,
  EngagementType.FOLLOW,
  EngagementType.SUBSCRIBE,
];

export const adminTransactionsSortMenu = [
  { text: "Oldest", sortBy: SortBy.updated_at_asc },
  { text: "Amount: High to Low", sortBy: SortBy.amount_desc },
  { text: "Amount: Low to High", sortBy: SortBy.amount_asc },
];

export const typeFilterMenu = [
  {
    text: "Credit",
    filterBy: TransactionType.CREDIT,
  },
  {
    text: "Debit",
    filterBy: TransactionType.DEBIT,
  },
];

export const categoryFilterMenu = [
  {
    text: "Revoke",
    filterBy: TransactionCategory.REVOKE,
  },
  {
    text: "Gift",
    filterBy: TransactionCategory.GIFT,
  },
  {
    text: "Item Purchase",
    filterBy: TransactionCategory.ITEM_PURCHASE,
  },
  {
    text: "Challenges",
    filterBy: TransactionCategory.QUEST,
  },
  {
    text: "Engagement",
    filterBy: TransactionCategory.ENGAGEMENT,
  },
  {
    text: "Social Login",
    filterBy: TransactionCategory.SOCIAL_LOGIN,
  },
  {
    text: "Welcome",
    filterBy: TransactionCategory.WELCOME,
  },
  {
    text: "Revert",
    filterBy: TransactionCategory.REVERT,
  },
];

export const statusFilterMenu = [
  {
    text: "Completed",
    filterBy: TransactionStatus.COMPLETED,
  },
  {
    text: "Pending",
    filterBy: TransactionStatus.PENDING,
  },
  {
    text: "Failed",
    filterBy: TransactionStatus.FAILED,
  },
];

export const revertTransactionCategoryDescription: Record<string, string[]> = {
  [TransactionCategory.ITEM_PURCHASE]: [
    "User will no longer have the items in their account",
    "Points will be credited back to the user",
    "Item inventory will be updated",
    "A new revert transaction will be created corresponding to the original transaction",
  ],
  [TransactionCategory.ENGAGEMENT]: [
    "Points will be debited from the user",
    "No. of engagement claims will be updated",
    "Related engagement will be removed from user account",
    "A new revert transaction will be created corresponding to the original transaction",
  ],
  [TransactionCategory.SOCIAL_LOGIN]: [
    "Points will be debited from the user",
    "Related engagement will be removed from user account",
    "A new revert transaction will be created corresponding to the original transaction",
  ],
  [TransactionCategory.WELCOME]: [
    "Points will be debited from user",
    "A new revert transaction will be created corresponding to the original transaction",
  ],
  [TransactionCategory.GIFT]: [
    "Points will be debited from user",
    "A new revert transaction will be created corresponding to the original transaction",
  ],
  [TransactionCategory.QUEST]: [
    "Points will be debited from user",
    "Challenge inventory will be updated",
    "Challenge status will be updated to Rejected state",
    "A new revert transaction will be created corresponding to the original transaction",
  ],
  [TransactionCategory.REVOKE]: [
    "Points will be credited back to user",
    "A new revert transaction will be created corresponding to the original transaction",
  ],
};
